jQuery(function ($) {
  let country_code = '';
  let country_name = '';
  fetch(
  window.Shopify.routes.root
    + 'browsing_context_suggestions.json'
    + '?country[enabled]=true'
    + `&country[exclude]=${window.Shopify.country}`
    + '&language[enabled]=true'
    + `&language[exclude]=${window.Shopify.language}`
).then(r => r.json())
.then(res=> {

 
  country_code = res.detected_values.country.handle;
  country_name = res.detected_values.country_name;
  console.log('country_code'+country_code);

     $('.cur_loca_name').text(country_name);
  

 
  
    if(country_code  == 'US'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg" alt="national flag icon"/>');
    $('.aviation_warn li:last-child').text('In Virgin a, Puerto Rico, Alaska, Guam, Hawaii, only 4 devices can be shipped by air.');
    }if(country_code  == 'BR'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/190073fb7652e7c635a1b91af0286b3c.svg" alt="national flag icon"/>');
    }if(country_code  == 'AU'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg" alt="national flag icon"/>');
    }if(country_code  == 'CA'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg" alt="national flag icon"/>');
    }if(country_code  == 'DK'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/e60c493fdbe69069d943ecc37287aa90.svg" alt="national flag icon"/>');
    }if(country_code  == 'MX'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/2bcda95713919c2134876a7da635da80.svg" alt="national flag icon"/>');
    $('.aviation_warn').html('<li>Shop in MXN</li><li>Less than $300USD</li><li>Only 4 devices can be shipped by air.</li>');
    }if(country_code  == 'NO'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d8dd9ad33e2d0c876096fbdfd87bcf31.svg" alt="national flag icon"/>');
    }if(country_code  == 'PL'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/965125896e906dc4ccbf65fa398c386c.svg" alt="national flag icon"/>');
    }if(country_code  == 'SE'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/637920f30b717c7f4e826a4bb63bb552.svg" alt="national flag icon"/>');
    }if(country_code  == 'CH'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/a5d4c82835e435ecff150a9a3426fed2.svg" alt="national flag icon"/>');
    }if(country_code  == 'GB'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg" alt="national flag icon"/>');
    }if(country_code  == 'AE'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg" alt="national flag icon"/>');
    }if(country_code  == 'EZ'){
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg" alt="national flag icon"/>');
    }
  if(country_code != 'BR' &&country_code != 'AU'&&country_code != 'CA'&&country_code != 'DK'&&country_code != 'MX'&&country_code != 'NO'&&country_code != 'PL'&&country_code != 'SE'&&country_code != 'CH'&&country_code != 'GB'&&country_code != 'UA'&&country_code != 'EZ'){
    $('.cur_loca_name').text('United States');
    $('.loca_name').text('United States');
    $('.aviation_warn li:last-child').text('In Virgin a, Puerto Rico, Alaska, Guam, Hawaii, only 4 devices can be shipped by air.');
      $(".flag_icon").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg" alt="national flag icon"/>');
      
  }
  /*if(country_code == 'KR' ){
    $('#cur_location.on').css('display','none');
    }
      */
  
});

  $('.recommendation-modal__button--minimal').click(function(){
    $('#pop_cont1').hide();
    $(this).hide();
    $('#pop_cont2').show(); 
  });
   $('.loca_pop_close').click(function(){
  
  });

var locaPopup = function() {
  
  var handleCookie = {
    setCookie: function (name, val, exp) {
      var date = new Date();
      
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      console.log(name + "=" + val + ";expires=" + date.toUTCString() + ";path=/");
      
      document.cookie = name + "=" + val + ";expires=" + date.toUTCString() + ";";
    },
    getCookie: function (name) {
      var value = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
      return value ? value[2] : null;
    }
  };
  console.log(handleCookie.getCookie("today"));
  
  if (handleCookie.getCookie("today") == "y") {
    $("#cur_location").removeClass("on");
  } else {
    $("#cur_location").addClass("on");
  }

  $("#cur_location").on("click", ".recommendation-modal__button", function () {
    handleCookie.setCookie("today", "y", 1);
    $(this).parents("#cur_location.on").removeClass("on");
  });
$("#cur_location").removeClass("on");
  $('.Header__CurrencySelector').click(function(){
    if($("#cur_location").hasClass('on')){
      $("#cur_location").removeClass('on');
    }else{
      
    $("#cur_location").addClass("on");
    }
      
  });

}

$(function() {
  locaPopup();
});
 });
 